
const Aws = () => {
  return (
    <div className="mt-4 text-center">
        <h1 className="display-6 text-warning">AWS/DevOps Path</h1>
        <p>
            We prepare you for AWS DevOps certifications. Our graduates land the best IT jobs!
        </p>
        <img 
            src="https://clarusway.com/wp-content/uploads/elementor/thumbs/Aws-Solution-Architech-1-pmxc3z6r0ibsy5uixyzfrgrdilrq8nu5yid937d8w8.jpg"
            alt=""
            className="img-fluid"
        />
        <div className="container mb-5">
            <button className="btn btn-outline-warning btn-light mt-4 mb-4">Learn More</button>
        </div>

    </div>
  )
}

export default Aws